import React, { useState, useEffect } from 'react';
import { X, Trash2 } from 'lucide-react';
import DeleteProjectModal from './DeleteProjectModal';

function ManageProjectModal({ project, onClose, onUpdateProject, onDelete, employeeData }) {
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);



  // Ensure employees is always an array
  const [editedProject, setEditedProject] = useState({
    ...project,
    employees: Array.isArray(project.Employeelist) ? project.Employeelist : [] // Check if Employeelist is an array
  });

  // Create a set of employee ids that are already part of the project
  const employeeIdsInProject = new Set(editedProject.employees.map(emp => emp._id));

  const handleEmployeeSelection = (e) => {
    const employeeId = e.target.value;
    const isSelected = e.target.checked;

    // Update the project employee list based on checkbox state
    const updatedEmployees = isSelected
      ? [...editedProject.employees, employeeData.find(emp => emp._id === employeeId)] // Add employee
      : editedProject.employees.filter(emp => emp._id !== employeeId); // Remove employee

    // Update state with the modified employee list
    setEditedProject({
      ...editedProject,
      employees: updatedEmployees
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onUpdateProject(editedProject);
    onClose();
  };

  const handleDelete = () => {
    onDelete(project._id);
    setIsDeleteModalOpen(false); // Close delete modal after successful deletion
    onClose(); // Close the main modal
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-lg max-w-2xl w-full p-6">
        <div className="flex justify-between items-center mb-6">
          <h2 className="text-xl font-semibold text-gray-900">Manage Project</h2>
          <button onClick={onClose} className="text-gray-400 hover:text-gray-500">
            <X className="h-5 w-5" />
          </button>
        </div>

        <form onSubmit={handleSubmit} className="space-y-6">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Project Name</label>
            <input
              type="text"
              className="w-full p-2 border rounded-lg"
              value={editedProject.projectName}
              onChange={(e) =>
                setEditedProject({ ...editedProject, projectName: e.target.value })
              }
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Description</label>
            <textarea
              className="w-full p-2 border rounded-lg"
              rows={3}
              value={editedProject.projectDescription}
              onChange={(e) =>
                setEditedProject({ ...editedProject, projectDescription: e.target.value })
              }
            />
          </div>

          <div>
            <div className="flex justify-between items-center mb-3">
              <label className="text-sm font-medium text-gray-700">Team Members</label>
            </div>

            <div className="space-y-2">
              {/* Scrollable employee list */}
              <div className="max-h-60 overflow-y-auto">
                {employeeData.map((emp) => (
                  <div key={emp._id} className="flex justify-between items-center p-3 bg-gray-50 rounded-lg">
                    <div>
                      <p className="font-medium text-gray-900">{emp.employeeName}</p>
                    </div>
                    <div>
                      <input
                        type="checkbox"
                        value={emp._id} // Use _id as the value for the checkbox
                        checked={employeeIdsInProject.has(emp._id)} // Check if the employee is already part of the project
                        onChange={handleEmployeeSelection}
                        className="form-checkbox h-5 w-5 text-blue-600"
                      />
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          <div className="flex gap-3 pt-4 border-t">
            <button
              type="submit"
              className="flex-1 bg-blue-600 text-white py-2 rounded-lg hover:bg-blue-700"
            >
              Save Changes
            </button>
            <button
              type="button"
              onClick={() => setIsDeleteModalOpen(true)} // Open delete modal
              className="flex-1 bg-red-600 text-white py-2 rounded-lg hover:bg-red-700"
            >
              Delete Project
            </button>
            <button
              type="button"
              onClick={onClose}
              className="flex-1 bg-gray-100 text-gray-700 py-2 rounded-lg hover:bg-gray-200"
            >
              Cancel
            </button>
          </div>
        </form>
      </div>
      <DeleteProjectModal
        isOpen={isDeleteModalOpen}
        onClose={() => setIsDeleteModalOpen(false)}
        onDelete={handleDelete}
        projectName={project?.projectName}
      />
    </div>
    
  );
}

export default ManageProjectModal;
